import { coerceWireValues } from "@sidegigllc/api/client";
import type { PersistedClient } from "@tanstack/react-query-persist-client";

// JSON.parse drops Date-ness; re-apply customFetch's wire coercion to query data only, so keys still hash the same (CORE-9012).
export const deserializeCache = (cached: string): PersistedClient => {
  const client = JSON.parse(cached) as PersistedClient;
  for (const query of client.clientState.queries) {
    query.state.data = coerceWireValues(query.state.data);
  }
  return client;
};
